define('controllers/trade',['require','underscore','mediator','controllers/base/controller','views/pages/trade/index','models/pages/trade/index'],function(require) {
    'use strict';

    var _ = require('underscore'),
        mediator = require('mediator'),
        Controller = require('controllers/base/controller'),
        TradePageView = require('views/pages/trade/index'),
        TradePageModel = require('models/pages/trade/index');

    var TradeController = Controller.extend({
        show: function(params, a, o) {

            var data = {
                tradeId: params.tradeId,
                state: params.state,
                search: o.query.search ? o.query.search : '',
                page: params.page
            };

            var model = new TradePageModel(data);

            this.view = new TradePageView({
                model: model
            });

            model.load(true);

        },

        requests: function() {

        }
    });

    return TradeController;
});

